/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { makeStateKey, TransferState } from '@angular/core';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';

export const ROOT_STATE_KEY = makeStateKey<IState>('app-app');

export interface IState {
  router?: RouterReducerState;
}

export const reducers: ActionReducerMap<IState, any> = {
  router: routerReducer
};

export function getInitialState(transferState: TransferState): IState {
  const state = transferState.get<IState>(ROOT_STATE_KEY, {});
  transferState.remove(ROOT_STATE_KEY);

  return state;
}
